<div class="process-status" [ngSwitch]="currentProcessStatus">
  <ng-container *ngSwitchCase="processStatus.InProgress">
    <img src="/assets/img/icons/ellipse.png" alt=""/>
    <span class="blue-color">Processing</span>
  </ng-container>
  <ng-container *ngSwitchCase="processStatus.Finished">
    <i class="material-icons green-color">done</i>
    <span class="green-color">{{ currentProcessStatus }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="processStatus.TimedOut">
    <i class="material-icons red-color">warning</i>
    <span class="red-color">Timed out</span>
  </ng-container>
  <ng-container *ngSwitchCase="processStatus.Idle">
    <i class="material-icons red-color">warning</i>
    <span class="red-color">{{ currentProcessStatus }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="processStatus.Canceled">
    <i class="material-icons red-color">warning</i>
    <span class="red-color">{{ currentProcessStatus }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="processStatus.Failed">
    <i class="material-icons red-color">warning</i>
    <span class="red-color">{{ currentProcessStatus }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="processStatus.VersionCheck">
    <i class="material-icons green-color">done</i>
    <span class="green-color">{{ currentProcessStatus }}</span>
  </ng-container>
</div>
